import { BaseModel } from 'paliari-js-utils'
import Anexo from './Anexo'
import Usuario from './Usuario'

const attributes = {
  id: null,
  descricao: '',
  usuario_id: null,
  realizado_em: 'now',
  comentario_situacao_id: null,
  comentario_situacao: (p = {}) => p,
  usuario: obj => (obj ? new Usuario(obj) : null),
  anexos: (p = []) => p.map(item => new Anexo(item)),
}

class Comentario extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
    if (
      !this.comentario_situacao_id &&
      this.comentario_situacao &&
      this.comentario_situacao.id
    ) {
      this.comentario_situacao_id = this.comentario_situacao.id
    }
  }
}

export default Comentario
